import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Layout, Typography } from 'antd';
import * as Sentry from '@sentry/react';
import { saveTokens } from 'services/auth';
import { firebaseAuth } from 'services/firebase/firebase-auth';
import { useAuthMutation } from 'api/auth/use-auth';
import type { TClientUserRes } from 'api/swagger';
import { clientRouterPaths } from 'client-app/router/client-router-paths';
import { useClientAuthStore } from 'client-app/stores/use-client-auth-store';
import styles from './login-finish.module.scss';

export const LoginFinish: FC = () => {
  const navigate = useNavigate();
  const { setAuth } = useClientAuthStore();
  const [error, setError] = useState<string | null>(null);

  const { mutate: authMutation } = useAuthMutation({
    handleSuccess: (data) => {
      Sentry.setUser({
        id: data?.clientUser?.id,
        email: data?.clientUser?.email,
        clientId: data?.clientUser?.clientId,
      });
      saveTokens(data);
      setAuth(data.clientUser as TClientUserRes);
      navigate(clientRouterPaths.home);
    },
    handleError: () => {
      setError(
        "It looks like you don't have access to the client cabinet. Please contact your personal assistant Tankel.",
      );
    },
  });

  const sendToken = (token: string) => authMutation({ type: 'client', token });

  useEffect(() => {
    const checkAuth = async () => {
      const token = await firebaseAuth.emailLinkFinish();

      if (token) {
        sendToken(token);
      }
    };

    checkAuth();
  }, []);

  if (error) {
    return (
      <Layout className={styles.main}>
        <Card className={styles.card}>
          <img src='/tankel.png' alt='Tankel Logistics' width={110} />
          <p>{error}</p>
          <Typography.Link href={clientRouterPaths.auth} underline>
            Go to Login Page
          </Typography.Link>
        </Card>
      </Layout>
    );
  }

  return <div />;
};
